"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { Icon } from "../../components/Icon";
import { getModulesData, TabItem } from "./modules_data";

type Cat = "all" | "clinical" | "ops" | "fin" | "comp";

export function ModulesGrid({ locale }: { locale: string }) {
  const t = getModulesData(locale);
  const [active, setActive] = useState<Cat>("all");

  return (
    <>
      <div className="cat-strip reveal">
        {t.tabs.map((tab) => (
          <button
            key={tab.cat}
            type="button"
            className={active === tab.cat ? "is-active" : undefined}
            onClick={() => setActive(tab.cat)}
          >
            {tab.label} <span className="ct">{tab.count}</span>
          </button>
        ))}
      </div>

      <div className="modules-hero-grid" data-reveal-group>
        {t.modules.map((m) => {
          const visible = active === "all" || active === m.cat;
          return (
            <motion.article
              key={m.title}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className={`mod-tile ${m.cat} reveal`}
              style={visible ? undefined : { display: "none" }}
            >
              <span className="mod-tag">{m.catLabel}</span>
              <span className="mod-ic">
                <Icon name={m.icon} />
              </span>
              <h2>{m.title}</h2>
              <p>{m.desc}</p>
            </motion.article>
          );
        })}
      </div>
    </>
  );
}
